import { easter } from "date-easter";

/*
* Check if today is Easter or within a range of days before or after Easter
* @param {number} nbDaysBefore - Number of days before Easter to include
* @param {number} nbDaysAfter - Number of days after Easter to include
* @returns {boolean} - True if today is Easter or within the specified range, false otherwise
*/
export const isEasterToday = (nbDaysBefore = 1, nbDaysAfter = 2) => {
    try {
        const DAY = 24 * 60 * 60 * 1000;
        const easterInfos = easter(new Date().getFullYear()); // Returns the Easter sunday date
        const easterDate = new Date(easterInfos.year, easterInfos.month - 1, easterInfos.day).getTime();
        const today = new Date().getTime();
        return easterDate - (nbDaysBefore * DAY) <= today && easterDate + (nbDaysAfter * DAY) >= today;
    } catch (err) {
        return false;
    }
}
